import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
// import AboutUs from "./components/AboutUs";
import PastClients from "./components/PastClients";
import Testimonials from "./components/Testimonials";
import Staff from "./components/staff";
import Contact from "./pages/Contact";
// import Services from "./components/Services";
import TermsAndConditions from "./pages/TermsAndConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy";

import ProtectedRoute from "./components/ProtectedRoute";

//Parent .jsx page
import Portal from "./pages/Portal";
// Child .jsx pages
import PortalHome from "./pages/PortalHome";
import SalesQtyByMonth from "./pages/SalesQtyByMonth";
import Last9MonthSales from "./pages/Last9MonthSales";
import MainDashboard from "./pages/MainDashboard";





function App() {
  return (
    <Router>
      <Navbar />
      <div className="app-shell">
        <Routes>
          <Route path="/" element={<Home />} />
          {/* <Route path="/about" element={<AboutUs />} />
          <Route path="/services" element={<Services />} /> */}
          <Route path="/past-clients" element={<PastClients />} />
          <Route path="/testimonials" element={<Testimonials />} />
          <Route path="/staff" element={<Staff />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />}/>
          <Route path="/privacy-policy" element={<PrivacyPolicy />}/>
          
          {/* Protected client portal --- Metric Pages nested inside so API call in Portal.jsx stays mounted  */}
          <Route path="/portal" element={<ProtectedRoute><Portal /></ProtectedRoute>}>
            <Route index element={<ProtectedRoute><PortalHome /></ProtectedRoute>} />
            <Route path="Sales-qty-by-month" element={<ProtectedRoute><SalesQtyByMonth /></ProtectedRoute>} />
            <Route path="Last-9-Months-Sales" element={<ProtectedRoute><Last9MonthSales /></ProtectedRoute>} />
            <Route path="Main-Dashboard" element={<ProtectedRoute><MainDashboard /></ProtectedRoute>} />
          </Route>
          {/*Old Version of Metrics Pages - Portal.jsx dismounted at page leave */}
          {/*<Route path="/portal/Last-9-Months-Sales" element={
            <ProtectedRoute>
              <Last9MonthSales />
            </ProtectedRoute>
            }
          />*/}
        </Routes>
      </div>
      <Footer />
    </Router>
  );
}

export default App;
